import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { EFormSource } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/FormSelector'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import React, { useState } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Button, IButtonProps } from 'core-components/library/button'
import {
  DatePicker,
  IDatePickerMultiple,
  IDatePickerRange,
  IDatePickerSingle,
} from 'core-components/library/datepicker'
import { DropdownDynamic } from 'core-components/library/dropdown'
import { IDropdownDynamicProps } from 'core-components/library/dropdown/DropdownDynamic'
import { LoaderOverlay } from 'core-components/library/loader'
import { Controller } from 'core-components/library/validation'
import { IFormCollector } from 'core/classes/models/IFormCollector'
import {
  IAudienceCondition,
  VisualAudienceExtended,
} from 'core/components/shared/ui/VisualAudienceExtended'
import { CrudStore } from 'core/types/crudStore'
import { refreshContractSignatureProgressData } from 'onboarding/features/actions/refreshProgressData'
import { DateHelper } from 'onboarding/utils/dateHelper'

import { useContractData } from './hooks/useContractData'
import { ReadOnlyField } from './ReadOnlyField'

import styles from './ContractData.module.scss'

interface IProps {
  requestId: string
  audienceSettings: IAudienceCondition
}

interface IDatePickerData {
  field: string
  label: string
}

const datePickersArray: IDatePickerData[] = [
  { field: 'IssueOutDate', label: 'Agreement issue out date' },
  { field: 'AgreementReject', label: 'Agreement reject date' },
  { field: 'PartnerSignature', label: 'Partner signature date' },
  { field: 'Activated', label: 'Activated Date' },
]

export const ContractDataRequestor = (props: IProps) => {
  const dispatch = useAppDispatch()
  const [item, setItem] = useState<IObjectAny>({})
  const [wip, setWip] = useState(true)
  const source = CrudStore.get(CrudStoreItemOnboarding.ContractsFormData)
  const completenessFormsSource = CrudStore.get<IFormCollector>(
    CrudStoreItem.FormCollector,
    'data_collector_table'
  )
  const { cruds } = useContractData(
    (value) => {
      setItem(value)
      setWip(false)
    },
    props.requestId,
    source
  )

  const onSave = async () => {
    setWip(true)
    const formData: IForm | null = await source.getById({
      id: props.requestId,
      force: true,
      keyField: 'RequestId',
    })
    const itemToUpdateOrCreate = formData ? { ...formData, ...item } : item
    await source[formData ? 'update' : 'create'](EFormSource.ContractFollowUp, [
      {
        ...itemToUpdateOrCreate,
        RequestId: props.requestId,
      },
    ])
    setWip(false)
    completenessFormsSource.triggerOnChange()
    dispatch(refreshContractSignatureProgressData())
  }

  const onChange = (field: string) => (value: string | number) => {
    setItem({ ...item, [field]: value })
  }

  const { audienceSettings } = props

  return (
    <Controller>
      <div className={styles.content}>
        <LoaderOverlay show={wip} />
        <div className={styles.bottomWrapper}>
          <ReadOnlyField label={'Current Contract Status'} value={item.ContractStatus || null} />
        </div>
        <VisualAudienceExtended<IDropdownDynamicProps>
          write={audienceSettings}
          component={DropdownDynamic}
          margin={'md'}
          label={'Business Status'}
          source={cruds.businessStatuses}
          value={item.BusinessStatus}
          caption={'en'}
          onChange={(_, item) => onChange('BusinessStatus')(item.value)}
        />
        {datePickersArray.map((el, index) => (
          <VisualAudienceExtended<IDatePickerSingle | IDatePickerRange | IDatePickerMultiple>
            margin={'md'}
            key={index}
            write={audienceSettings}
            component={DatePicker}
            mode={'single'}
            value={
              item[el.field]
                ? DateHelper.convertServerISOToDate(item[el.field]) || undefined
                : undefined
            }
            onChange={(value: Date) => {
              let formattedDate = ''
              if (value) {
                formattedDate = DateHelper.convertDateToServerISO(value)
              }
              onChange(el.field)(formattedDate)
            }}
            label={el.label}
          />
        ))}
        <div className={styles.btnWrapper}>
          <VisualAudienceExtended<IButtonProps>
            write={audienceSettings}
            component={Button}
            onClick={onSave}
          >
            Save
          </VisualAudienceExtended>
        </div>
      </div>
    </Controller>
  )
}
